import * as UnitTypes from "../consts/ProductCountOptions";
/**
 * Comprueba si un tipo de unidad es válido y es por UNIDAD.
 * @param {string} unit_type - El tipo de unidad que se va a comprobar.
 * @returns {boolean} Devuelve true si el tipo de unidad es válido, de lo contrario devuelve false.
 */
export const isTypeUnits = (unit_type) => {
  return unit_type === UnitTypes.UNIT.value || unit_type === UnitTypes.UNIT.intValue;
}